/**
 * La barretta del punteggio nelle tendine: quanto è piena, e con quale passo.
 *
 * Vive fuori da `EditableField` per una ragione pratica — un file che esporta sia componenti sia
 * costanti perde il fast refresh — e per una di sostanza: la soglia sotto la quale un punteggio
 * «non dice niente» la usa anche chi decide quali opzioni proporre, non solo chi le disegna.
 */

/**
 * Valore sotto il quale la barretta resta vuota, e sotto il quale un'opzione non vale la pena di
 * essere proposta.
 *
 * Non è zero, e non è un'arbitrarietà estetica: sotto questa soglia il punteggio non sceglie
 * nulla, quindi disegnare un quinto di barra per uno 0,2 suggerirebbe una somiglianza che non
 * conta. Barra vuota significa «sotto la soglia», non «zero».
 */
// SYNC CROSS-LAYER con _DROPDOWN_FLOOR di ProductDescriptionMatcher (trentino-sicurezza): lì decide
// quando la tendina ha una sola alternativa, che la riga prende da sola.
export const METER_FLOOR = 0.4;

/** Ampiezza di un passo. */
export const METER_STEP = 0.05;

/** Quanti passi ha la barretta fra {@link METER_FLOOR} e 1: dodici, più lo zero. */
export const METER_STEPS = Math.round((1 - METER_FLOOR) / METER_STEP);

/**
 * Il passo della barretta per un valore fra 0 e 1.
 *
 * Il colore lo mette il CSS, una classe per passo: rosso al primo, verde all'ultimo, giallo in
 * mezzo.
 */
export function meterStep(value: number): number {
  const step = Math.round((value - METER_FLOOR) / METER_STEP);

  return Math.min(METER_STEPS, Math.max(0, step));
}
